import { render, staticRenderFns } from "./NominateMemberPresidentApproval.vue?vue&type=template&id=6616f093&scoped=true"
import script from "./NominateMemberPresidentApproval.vue?vue&type=script&lang=js"
export * from "./NominateMemberPresidentApproval.vue?vue&type=script&lang=js"
import style0 from "./NominateMemberPresidentApproval.vue?vue&type=style&index=0&id=6616f093&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6616f093",
  null
  
)

export default component.exports